<template>
  <div id="menu_artifact_type">
    <v-row class="d-flex" justify="center">
      <v-menu
        v-if="currentArtifactType"
        v-model="showMenu"
        transition="slide-y-transition"
        absolute
        :style="position"
      >
        <v-list rounded>
          <v-list-subheader>{{ currentArtifactType.name }}</v-list-subheader>

          <v-divider></v-divider>

          <v-list-item
            v-for="(item, i) in menuItems"
            :key="i"
            :disabled="item.disabled"
            @click="item.action"
          >
            <template #prepend>
              <v-icon>{{ item.icon }}</v-icon>
            </template>

            <v-list-item-title>{{ item.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>
  </div>
</template>

<script lang="ts" setup>
  import { ArtifactType } from '@/models'
  import * as joint from '@clientio/rappid'
  import labels from '@/translations/labels.json'
  import { EventBus } from '@/event-bus'
  import { Events } from '@/models/events.model'
  import { computed, ref } from 'vue'
  import { useEventBus } from '@/utils/events'
  import CONSTANTS from '@/constants/Config.constants'

  const currentArtifactType = ref<ArtifactType>()
  const burgerMenu = ref<joint.elementTools.Button>()
  const currentCell = ref<joint.dia.CellView>()
  const showMenu = ref(false)
  const position = ref('')

  const menuItems = computed(() => [
    {
      text: labels.EXPLORER.PROPERTIES,
      icon: CONSTANTS.ICONS_MDI.ICON_VIEW_LIST_OUTLINE,
      action: showProperties,
      disabled: false,
    },
    {
      text: getCollapsedStatus(),
      icon: CONSTANTS.ICONS_MDI.ICON_VIEW_LIST_OUTLINE,
      action: toggleCollapseContainer,
      disabled: currentArtifactType.value && currentArtifactType.value.artifactCount === 0,
    },
  ])

  useEventBus('openContainerMenuArtifactType', setArtifactType)

  function getCollapsedStatus(): string {
    return currentArtifactType.value?.collapsed ? labels.EXPLORER.EXPAND : labels.EXPLORER.COLLAPSE
  }

  function setArtifactType(inputData: Events['openContainerMenuArtifactType']): void {
    showMenu.value = true
    currentArtifactType.value = inputData.artifactType
    currentCell.value = inputData.cellView

    let posX = inputData.position.x
    let posY = inputData.position.y
    if (inputData.button) {
      burgerMenu.value = inputData.button
      posX = inputData.button.el.getBoundingClientRect().x
      posY = inputData.button.el.getBoundingClientRect().y
    }
    position.value = `left:${posX}px; top:${posY}px !important;`
  }

  // ContainerMenu actions:
  function showProperties(): void {
    if (currentArtifactType.value !== undefined) {
      EventBus.emit('updatePropertiesArtifactType', currentArtifactType.value as ArtifactType)
    }
  }

  function toggleCollapseContainer(): void {
    if (currentArtifactType.value !== undefined && currentCell.value !== undefined) {
      EventBus.emit('updateContainerToggleCollapse', {
        artifactType: currentArtifactType.value,
        cellView: currentCell.value?.model || currentCell.value,
      })
    }
  }
</script>
